import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const organizationRolesAdapter = getAdapter({ idFieldName: 'value' });

// Use the adapter to generate the initial state
const initialState = organizationRolesAdapter.getInitialState({
  // You can add additional fields here if needed
  organizationRoles: [],
});

const organizationRolesSlice = createSlice({
  name: 'organizationRoles',
  initialState,
  reducers: {
    setOrganizationRoles: (state, { payload: { organizationRoles } }) => {
      organizationRolesAdapter.setAll(state, organizationRoles);
    },
  },
});

const selectors = organizationRolesAdapter.getSelectors(({ organizationRoles = [] } = {}) => organizationRoles);

export const getOrganizationRoles = (state) => state && selectors.selectAll(state);

export const {
  setOrganizationRoles,
} = organizationRolesSlice.actions;

export default organizationRolesSlice.reducer;
